import * as Baseline from './components/contexts/Baseline'

import React from 'react';

import { createMuiTheme } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/core/styles';

import { create } from 'jss';
import { StylesProvider, jssPreset } from '@material-ui/core/styles';
import increaseSpecificity from 'jss-increase-specificity';

import { SnackbarProvider } from 'notistack';

import {
	 PluginProvider,
	 FetchProvider,
	 ToastProvider,
	 RestApiProvider,
} from './components/contexts';

import { Routes } from './components/routing';

import { Layout } from './components/layout';

import './components/localization/i18n';

const theme = createMuiTheme({
	 palette: {
		  primary: {
				main: "#7957d5"
		  },
		  secondary: {
				main: "#F38F1A"
		  },
		  text: {
				secondary: "#515151"
		  }
	 },
	 overrides: {
		  MuiInputBase: {
				input: {
					 minHeight: "0",
					 "&:focus": {
						  outline: "none !important",
						  boxShadow: "none !important"
					 }
				},
		  },
		  MuiStepIcon: {
				root: {
					 '&$active': {
						  color: "#7957d5",
					 },
					 '&$completed': {
						  color: "#d1d1d1",
					 },
				},
		  },
		  MuiSwitch: {
		  },
		  MuiCheckbox: {
				colorSecondary: {
					 color: '#7957d5',
					 '&$checked': {
						  color: '#7957d5',
					 },
				},
		  },
		  MuiTabs: {
				indicator: {
					 backgroundColor: "#F38F1A"
				}
		  }
	 },
	 breakpoints: {
		  keys: ["xs", "sm", "md", "lg", "xl"],
		  up: (key) => `@media (min-width:${{
				xs: 0,
				sm: 600,
				md: 960,
				lg: 1150,
				xl: 1600,
		  }[key]}px)`

	 },
	 zIndex: {
		  snackbar: 999999
	 }
});

const jss = create({
	 plugins: [...jssPreset().plugins, increaseSpecificity({ repeat: 1 })],
});

// jQuery is included by WP
// To allow webpack to build and not giving error we are
// creating a local reference only if it exists 
// (basically when the javascript is executed inside the WordPress context)
let _jQuery = null;
if (typeof variable !== 'jQuery') {
	 _jQuery = window['jQuery'];
}

// wpApAdminSettings is a global variable defined in WP
// To allow webpack to build and not giving error we are
// creating a local reference only if it exists 
// (basically when the javascript is executed inside the WordPress context)
let _wpApAdminSettings = {};
if (typeof variable !== 'wpApAdminSettings') {
	_wpApAdminSettings = window['wpApAdminSettings'];
}

let registered = false;
if (!registered) { 

	function makeSyncPostRequest(url, data)
	{
		try {
			var xhr = new XMLHttpRequest();
			xhr.open("POST", url, false); // `false` makes the request synchronous

			// Set the request headers if needed
			xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
			xhr.setRequestHeader("MyFastAppToken1", Baseline.GetApiKeyInternal());

			// Send the request with the data
			xhr.send(JSON.stringify(data));

			// Check if the request was successful
			if (xhr.status === 200) {
				return xhr.responseText;
			} else {
				throw new Error('Request failed with status ' + xhr.status);
			}
		}
		catch { }
	}

	let data = {
		email					: _wpApAdminSettings.adminEmail,
		pluginVersion		: _wpApAdminSettings.pluginVersion,
		platformVersion	: _wpApAdminSettings.platformVersion
	};
	makeSyncPostRequest(_wpApAdminSettings.externalAPIUrl + "PLG_NotifyStarting", data);

	registered = true;
}


const App = ({ ...props }) => {

	 if (_jQuery)
		  _jQuery('body').removeClass('wp-core-ui wp-admin');

	 return (
		  <StylesProvider jss={jss}>
				<ThemeProvider theme={theme}>
					 <SnackbarProvider maxSnack={5}>
						  <ToastProvider>
								<PluginProvider>
									 <FetchProvider>
										  <RestApiProvider>
												<Layout>
													 <Routes />
												</Layout>
										  </RestApiProvider>
									 </FetchProvider>
								</PluginProvider>
						  </ToastProvider>
					 </SnackbarProvider>
				</ThemeProvider>
		  </StylesProvider>
	 );
};

export default App;